import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
	errorMessage: {
		color: "#eb5757",
		fontSize: "10.24px",
	},
}));
